import React from "react"
import { Alert } from "react-bootstrap"

export default ({ type, message, title }) => (
  <Alert variant={type}>
    {title ? <Alert.Heading>{title}</Alert.Heading> : null}
    <p>{message}</p>
  </Alert>
)
